import { useTranslator } from '@bluebeam/react-i18n';
import React, { FC, useContext } from 'react';
import AppStoreContext from 'contexts/AppStoreContext';
import { PostRFI } from 'records/interactions/PostRFI';

type PostRFIFooterProps = {
  interaction: PostRFI;
};

const PostRFIFooter: FC<PostRFIFooterProps> = (props) => {
  const { interaction } = props;
  const { translate } = useTranslator(['mapView']);

  return (
    <div
      className="pos-a flex-center"
      style={{ zIndex: 3, top: '128px', left: 'calc(50vw - 157.5px)' }}
    >
      <div
        className="bgd-black-1-opacity-80 white-1 px8 py3 flex-center b-radius-3"
        style={{ width: '315px' }}
      >
        {interaction.updatingMarkup
          ? translate('mapView:postRFIMessage.moveOrResizeMarkup')
          : translate('mapView:postRFIMessage.placeRFIMarkup')}
      </div>
    </div>
  );
};

const ManagePostRFIFooterWrapper: FC = () => {
  const { state: appState } = useContext(AppStoreContext);
  const a = appState.interactions.filter(
    (i): i is PostRFI => i.type === 'PostRFI'
  );

  if (a.size === 1) {
    return <PostRFIFooter interaction={a.get(0, new PostRFI())} />;
  }

  return null;
};

export default ManagePostRFIFooterWrapper;
